"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTabletBreakPoint = exports.isMobile = void 0;
var isMobile = function () {
    return window.matchMedia('only screen and (max-width: 920px)').matches;
};
exports.isMobile = isMobile;
var isTabletBreakPoint = function () {
    return window.matchMedia('only screen and (max-width: 767px)').matches;
};
exports.isTabletBreakPoint = isTabletBreakPoint;
